module.exports = __webpack_public_path__ + "7a6991e6fb01d99917e1bdda8115ca44.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/lato/lato-light-webfont.woff2
 ** module id = ./src/styles/fonts/lato/lato-light-webfont.woff2
 ** module chunks = 0
 **/